<template>
  <div class="dashboard-container">
    <div class="mb-2 page-title">
      <i class="bi bi-diagram-3"></i> Jenis &amp; Tarif Pertandingan
    </div>

    <!-- Pilih acara -->
    <section class="ui-card jt__blok">
      <div class="ui-card__body">
        <label class="ui-field">
          <span class="ui-label">Pilih Acara / Turnamen</span>
          <select v-model="tournamentId" class="ui-input" @change="muatSemua">
            <option value="">-- Pilih Turnamen --</option>
            <option v-for="t in turnamen" :key="t.id" :value="t.id">{{ t.name }}</option>
          </select>
        </label>
        <div v-if="turnamenTerpilih" class="mt-2 text-success fw-semibold">
          <i class="bi bi-trophy-fill text-warning me-1"></i>
          Turnamen Aktif: <strong>{{ turnamenTerpilih.name }}</strong>
          <span v-if="turnamenTerpilih.location" class="text-muted fw-normal ms-1">({{ turnamenTerpilih.location }})</span>
        </div>
        <p class="jt__teks mt-2">
          Jenis pertandingan dan tarif pendaftaran diatur <strong>khusus per turnamen</strong>.
        </p>
      </div>
    </section>

    <template v-if="tournamentId">
      <!-- Seksi 1: Jenis Pertandingan -->
      <section class="ui-card jt__blok">
        <div class="ui-card__body">
          <h2 class="jt__judul">
            <span class="jt__nomor">1</span> Jenis Pertandingan — <span class="text-primary">{{ turnamenTerpilih?.name }}</span>
          </h2>
          <p class="jt__teks">
            Tingkat <strong>Tanding</strong> (Pemasalan, Prestasi) dan kategori <strong>Seni</strong>
            yang dipertandingkan. Setiap baris di sini bisa diberi harga sendiri di bagian Tarif.
          </p>

          <!-- Tanding jenis -->
          <div class="jt__sub-jenis">
            <div class="jt__sub-judul">
              <i class="bi bi-shield-fill-check text-primary"></i> Tanding
            </div>
            <!-- Tombol isi cepat hanya untuk jenis yang belum ada, supaya tidak memicu galat "sudah dipakai". -->
            <div v-if="isiCepatTersisa.length" class="d-flex gap-2 mb-2 flex-wrap">
              <button
                v-for="nama in isiCepatTersisa"
                :key="nama"
                type="button"
                class="btn btn-sm py-0 px-2"
                :class="nama === 'Invitasi' ? 'btn-outline-primary' : 'btn-outline-secondary'"
                style="font-size: 0.75rem;"
                :disabled="sibuk"
                @click="isiCepatTanding(nama)"
              >+ {{ nama }}</button>
            </div>
            <form class="jt__baris-tambah" @submit.prevent="tambahJenis(1)">
              <input
                v-model.trim="jenisTandingBaru"
                class="ui-input"
                type="text"
                placeholder="mis. Pemasalan, Prestasi, Invitasi"
                maxlength="100"
              />
              <button type="submit" class="ui-btn ui-btn--secondary" :disabled="!jenisTandingBaru || sibuk">
                <i class="bi bi-plus-lg"></i> Tambah
              </button>
            </form>
            <ul v-if="jenisTandingList.length" class="jt__daftar">
              <li v-for="j in jenisTandingList" :key="j.id" class="jt__item">
                <span class="jt__badge jt__badge--tanding">Tanding</span>
                <input v-model.trim="j.name" class="ui-input jt__item-nama" maxlength="100" @change="ubahJenis(j)" />
                <button type="button" class="ui-btn ui-btn--sm aksi__item--bahaya" :disabled="sibuk" @click="hapusJenis(j)">
                  <i class="bi bi-trash"></i>
                </button>
              </li>
            </ul>
            <p v-else class="jt__kosong">Belum ada jenis Tanding.</p>
          </div>

          <!-- Seni: satu centang = kategori dibuka di formulir atlet + golongan tarif -->
          <div class="jt__sub-jenis mt-3">
            <div class="jt__sub-judul">
              <i class="bi bi-stars text-warning"></i> Seni
            </div>
            <p class="jt__teks">
              Centang kategori yang dipertandingkan. Yang dicentang langsung muncul di formulir atlet,
              dan masing-masing bisa diberi harga sendiri di bagian Tarif di bawah.
            </p>

            <div class="jt__tabel-bungkus">
              <table class="jt__matriks">
                <thead>
                  <tr>
                    <th scope="col">Kategori</th>
                    <th v-for="t in tingkatSeni" :key="t" scope="col" class="jt__tengah">
                      {{ t === 'Khusus' ? 'Invitasi' : t }}<small v-if="t === 'Khusus'" class="jt__catatan">super admin</small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="b in matriksSeni" :key="b.label">
                    <th scope="row">{{ b.label }}</th>
                    <td v-for="t in tingkatSeni" :key="t" class="jt__tengah">
                      <label class="jt__centang" :title="judulCentang(b, t)">
                        <input
                          type="checkbox"
                          :checked="b.tingkat[t].dibuka"
                          :disabled="sibuk || (t === 'Khusus' && !isOwner) || (b.tingkat[t].dibuka && b.tingkat[t].atlet > 0)"
                          :aria-label="`${b.label} ${t}`"
                          @change="aturSeni(b, t, $event.target.checked)"
                        />
                        <span v-if="b.tingkat[t].atlet" class="jt__atlet">{{ b.tingkat[t].atlet }} atlet</span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <form class="jt__baris-tambah mt-3" @submit.prevent="tambahBarisSeni">
              <select v-model="barisBaru.nomor" class="ui-input jt__pendek" aria-label="Nomor seni">
                <option v-for="n in ['Tunggal', 'Ganda', 'Regu', 'Solo Kreatif']" :key="n" :value="n">{{ n }}</option>
              </select>
              <input v-model.trim="barisBaru.varian" class="ui-input" maxlength="32" placeholder="Kategori lain, mis. Tangan Kosong" />
              <button type="submit" class="ui-btn ui-btn--secondary" :disabled="!barisBaru.varian || sibuk">
                <i class="bi bi-plus-lg"></i> Tambah baris
              </button>
            </form>

            <details v-if="golonganSeniLain.length" class="jt__lama mt-3">
              <summary>Golongan tarif seni lama ({{ golonganSeniLain.length }})</summary>
              <p class="jt__teks">
                Dipakai sebagai harga cadangan: kalau "Tunggal Senjata Prestasi" belum punya tarif,
                sistem memakai tarif "Tunggal Prestasi", lalu "Prestasi".
              </p>
              <ul class="jt__daftar">
                <li v-for="j in golonganSeniLain" :key="j.id" class="jt__item">
                  <span class="jt__badge jt__badge--seni">Seni</span>
                  <input v-model.trim="j.name" class="ui-input jt__item-nama" maxlength="100" @change="ubahJenis(j)" />
                  <button type="button" class="ui-btn ui-btn--sm aksi__item--bahaya" :disabled="sibuk" @click="hapusJenis(j)" :aria-label="`Hapus ${j.name}`">
                    <i class="bi bi-trash"></i>
                  </button>
                </li>
              </ul>
            </details>
          </div>
        </div>
      </section>

      <!-- Seksi 2: Tarif Pendaftaran -->
      <section class="ui-card jt__blok">
        <div class="ui-card__body">
          <h2 class="jt__judul">
            <span class="jt__nomor">2</span> Tarif Pendaftaran — <span class="text-primary">{{ turnamenTerpilih?.name }}</span>
          </h2>
          <p class="jt__teks">
            Biaya per atlet, ditentukan dari <strong>Tanding/Seni + Jenis + Kelompok Usia</strong>.
            Kosongkan Kelompok Usia kalau tarifnya sama untuk semua usia.
          </p>

          <form class="jt__massal" @submit.prevent="simpanMassal">
            <fieldset class="jt__massal-blok">
              <legend class="ui-label">1. Kategori <span class="jt__hitung">{{ pilihGolongan.length }} dipilih</span></legend>
              <div class="jt__pintasan">
                <button type="button" class="jt__pintas" @click="pilihGolonganSaat((g) => g.tingkat === 'Prestasi')">Semua Prestasi</button>
                <button type="button" class="jt__pintas" @click="pilihGolonganSaat((g) => g.tingkat === 'Pemasalan')">Semua Pemasalan</button>
                <button type="button" class="jt__pintas" @click="pilihGolonganSaat(() => true)">Semua</button>
                <button type="button" class="jt__pintas jt__pintas--redup" @click="pilihGolongan = []">Kosongkan</button>
              </div>

              <div v-for="k in kelompokGolongan" :key="k.judul" class="jt__massal-grup">
                <div class="jt__massal-grup-kepala">
                  <strong>{{ k.judul }}</strong>
                  <button type="button" class="jt__pintas" @click="alihkanGrup(k)">
                    {{ k.isi.every((g) => pilihGolongan.includes(g.id)) ? 'Lepas semua' : 'Pilih semua' }}
                  </button>
                </div>
                <div class="jt__chip-daftar">
                  <label v-for="g in k.isi" :key="g.id" class="jt__chip" :class="{ 'jt__chip--aktif': pilihGolongan.includes(g.id) }">
                    <input v-model="pilihGolongan" type="checkbox" :value="g.id" />
                    {{ g.labelPendek }}
                  </label>
                </div>
              </div>
              <p v-if="!kelompokGolongan.length" class="jt__kosong">Belum ada kategori. Isi dulu bagian 1 di atas.</p>
            </fieldset>

            <fieldset class="jt__massal-blok">
              <legend class="ui-label">2. Kelompok usia <span class="jt__hitung">{{ pilihUsia.length ? pilihUsia.length + ' dipilih' : 'semua usia' }}</span></legend>
              <div class="jt__chip-daftar">
                <label v-for="u in usia" :key="u.id" class="jt__chip" :class="{ 'jt__chip--aktif': pilihUsia.includes(u.id) }">
                  <input v-model="pilihUsia" type="checkbox" :value="u.id" />
                  {{ u.name }}
                </label>
              </div>
              <p class="jt__teks mt-2 mb-0">Tidak mencentang satu pun = satu harga untuk semua kelompok usia.</p>
            </fieldset>

            <div class="jt__massal-kaki">
              <label class="ui-field jt__massal-biaya">
                <span class="ui-label">3. Biaya per atlet (Rp)</span>
                <input v-model.number="biayaMassal" class="ui-input" type="number" min="0" step="1000" required placeholder="350000" />
              </label>
              <button type="submit" class="ui-btn ui-btn--primary" :disabled="sibuk || !pilihGolongan.length || biayaMassal === '' || biayaMassal === null">
                Simpan {{ jumlahKombinasi }} tarif
              </button>
            </div>
            <p v-if="jumlahKombinasi" class="jt__teks mb-0">Kombinasi yang sudah punya tarif akan diganti harganya.</p>
          </form>

          <div v-for="g in kelompokTarif" :key="g.judul" class="jt__grup">
            <h3 class="jt__grup-judul">{{ g.judul }} <span>{{ g.baris.length }}</span></h3>
            <div class="jt__tabel-bungkus">
              <table class="jt__tabel">
                <thead>
                  <tr>
                    <th v-if="g.adaKategori">Kategori</th>
                    <th>Tingkat</th>
                    <th>Kelompok Usia</th>
                    <th class="jt__kanan">Biaya (Rp)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="t in g.baris" :key="t.id">
                    <td v-if="g.adaKategori">{{ t._urai.kategori || '—' }}</td>
                    <td>{{ t._urai.tingkat || 'Semua' }}</td>
                    <td>{{ t.age_category?.name || 'Semua usia' }}</td>
                    <td class="jt__kanan">
                      <input
                        :value="Math.round(Number(t.biaya))"
                        class="ui-input jt__biaya"
                        type="number" min="0" step="1000"
                        :aria-label="`Biaya ${t._urai.kategori || g.judul} ${t._urai.tingkat} ${t.age_category?.name || 'semua usia'}`"
                        :disabled="sibuk"
                        @change="ubahBiaya(t, $event.target.value)"
                      />
                    </td>
                    <td class="jt__kanan">
                      <button type="button" class="ui-btn ui-btn--sm aksi__item--bahaya" :disabled="sibuk" @click="hapusTarif(t)" aria-label="Hapus baris tarif">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <p v-if="!tarifList.length" class="jt__kosong">
            Belum ada tarif. Selama kosong, sistem memakai biaya lama dari menu
            Kategori Turnamen — dan atlet yang tidak punya biaya di sana tidak
            bisa ditagih.
          </p>
        </div>
      </section>

      <!-- Seksi 3: Batas Peserta (kuota) -->
      <section class="ui-card jt__blok">
        <div class="ui-card__body">
          <h2 class="jt__judul"><span class="jt__nomor">3</span> Batas Peserta</h2>
          <p class="jt__teks">Kosongkan bila tidak dibatasi. Yang sudah penuh otomatis tidak bisa dipilih lagi.</p>

          <!-- Batas event -->
          <div class="bp-event" :class="{ 'bp-event--penuh': kuotaEvent.penuh }">
            <div class="bp-event__info">
              <span class="bp-event__label">Total atlet event</span>
              <strong class="bp-event__angka">
                {{ kuotaEvent.terisi }}<span v-if="kuotaEvent.kuota"> / {{ kuotaEvent.kuota }}</span>
              </strong>
              <span v-if="kuotaEvent.penuh" class="bp-tag bp-tag--merah">Penuh · pendaftaran ditutup</span>
              <span v-else-if="kuotaEvent.kuota" class="bp-tag">Sisa {{ kuotaEvent.sisa }}</span>
              <span v-else class="bp-tag">Tanpa batas</span>
            </div>
            <div v-if="kuotaEvent.kuota" class="bp-bar"><span :style="{ width: Math.min(100, (kuotaEvent.terisi / kuotaEvent.kuota) * 100) + '%' }"></span></div>
            <form class="bp-isi" @submit.prevent="aturKuotaEvent">
              <input v-model="kuotaEventInput" class="ui-input bp-input" type="number" min="1" max="100000" placeholder="mis. 3000" aria-label="Batas atlet event" />
              <button type="submit" class="ui-btn ui-btn--primary ui-btn--sm" :disabled="sibuk">Simpan</button>
            </form>
          </div>

          <div class="bp-tab" role="tablist">
            <button type="button" role="tab" :aria-selected="tabKuota === 'tanding'" :class="{ aktif: tabKuota === 'tanding' }" @click="tabKuota = 'tanding'">Tanding</button>
            <button type="button" role="tab" :aria-selected="tabKuota === 'seni'" :class="{ aktif: tabKuota === 'seni' }" @click="tabKuota = 'seni'">Seni</button>
          </div>

          <div v-for="g in (tabKuota === 'tanding' ? grupTanding : grupSeni)" :key="g.key" class="bp-grup">
            <div class="bp-grup__kepala">
              <div>
                <strong>{{ g.judul }}</strong>
                <span class="bp-redup">{{ g.items.length }} {{ g.satuan }}</span>
              </div>
              <form v-if="g.items.length > 1" class="bp-isi" @submit.prevent="simpanKuota(g, g.items, g.massal)">
                <input v-model="g.massal" class="ui-input bp-input" type="number" min="1" max="512" placeholder="Semua" :aria-label="`Batas semua ${g.judul}`" />
                <button type="submit" class="ui-btn ui-btn--secondary ui-btn--sm" :disabled="sibuk">Terapkan</button>
              </form>
            </div>
            <div class="bp-daftar">
              <label v-for="it in g.items" :key="it.key" class="bp-item">
                <span class="bp-item__nama">{{ it.label }}<small v-if="it.sub">{{ it.sub }}</small></span>
                <input :value="it.kuota ?? ''" class="ui-input bp-input" type="number" min="1" max="512" placeholder="∞"
                       :aria-label="`Batas ${g.judul} ${it.label}`" :disabled="sibuk"
                       @change="simpanKuota(g, [it], $event.target.value)" />
              </label>
            </div>
          </div>
          <p v-if="!(tabKuota === 'tanding' ? grupTanding : grupSeni).length" class="jt__kosong">
            {{ tabKuota === 'tanding' ? 'Belum ada kelompok usia untuk event ini.' : 'Belum ada nomor seni bertarif untuk event ini.' }}
          </p>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import http from '@/services/http';
import { isOwner } from '@/utils/peran';

const NOMOR = ['Solo Kreatif', 'Tunggal', 'Ganda', 'Regu', 'Tradisi'];
const URUT_NOMOR = ['Tunggal', 'Ganda', 'Regu', 'Solo Kreatif', 'Tradisi'];
const TINGKAT = ['Prestasi', 'Pemasalan', 'Invitasi'];

/** "Tunggal Tangan Kosong Pemasalan" -> { nomor, varian, tingkat }. */
function uraiGolongan(nama, induk) {
  const teks = String(nama || '').trim();
  // "Invitasi" adalah nama tampil untuk tingkat Khusus.
  const kata = ['Prestasi', 'Pemasalan', 'Khusus', 'Invitasi'].find((t) => new RegExp(`\\b${t}$`, 'i').test(teks)) || null;
  const tingkat = kata ? (kata === 'Khusus' ? 'Invitasi' : kata) : null;
  let sisa = kata ? teks.slice(0, -kata.length).trim() : teks;
  const nomor = Number(induk) === 1 ? 'Tanding' : (NOMOR.find((n) => sisa.toLowerCase().startsWith(n.toLowerCase())) || null);
  if (nomor && nomor !== 'Tanding') sisa = sisa.slice(nomor.length).trim();
  if (nomor === 'Tanding') sisa = sisa.replace(/^tanding\s*/i, '');
  return { nomor, varian: sisa || null, tingkat };
}
import { useToast } from 'vue-toastification';

export default {
  name: 'JenisTarifPage',

  setup() {
    return { toast: useToast() };
  },

  data() {
    return {
      turnamen: [],
      kejuaraan: [],
      usia: [],
      tournamentId: '',
      jenisList: [],      // semua jenis (untuk referensi)
      tarifList: [],
      jenisTandingBaru: '',
      jenisSeniBaru: '',
      tarifBaru: this.tarifKosong(),
      kuotaList: [],
      kuotaKelasList: [],
      kuotaSeni: { usia: [], nomor: [] },
      kuotaEvent: { kuota: null, terisi: 0, sisa: null, penuh: false },
      kuotaEventInput: '',
      tabKuota: 'tanding',
      pilihGolongan: [],
      pilihUsia: [],
      biayaMassal: null,
      sibuk: false,
      matriksSeni: [],
      tingkatSeni: ['Prestasi', 'Pemasalan', 'Khusus'],
      barisBaru: { nomor: 'Ganda', varian: '' },
    };
  },

  created() {
    this.muatAwal();
  },

  methods: {
    tarifKosong() {
      return {
        championship_category_id: '',
        jenis_pertandingan_id: null,
        age_category_id: null,
        biaya: null,
      };
    },

    /** Balasan kadang dibungkus {data:[...]}, kadang array polos. */
    isi(r) {
      const d = r?.data;
      return Array.isArray(d) ? d : (d?.data ?? []);
    },

    rupiah(n) {
      return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
    },

    async muatAwal() {
      try {
        let tData = [];
        try {
          const t = await http.get('/tournaments', { params: { fetch_all: true } });
          tData = this.isi(t);
        } catch (e) {
          console.warn('Gagal memuat /tournaments', e);
        }

        if (!tData || !tData.length) {
          try {
            const t3 = await http.get('/tournaments/all');
            tData = this.isi(t3);
          } catch (e) {
            console.warn('Gagal memuat /tournaments/all', e);
          }
        }

        const [k, u] = await Promise.all([
          http.get('/championship-categories').catch(() => ({ data: [] })),
          http.get('/age-categories').catch(() => ({ data: [] })),
        ]);

        this.turnamen = tData || [];
        this.kejuaraan = this.isi(k);
        this.usia = this.isi(u);

        // Pilih otomatis turnamen pertama jika ada
        if (this.turnamen.length > 0 && !this.tournamentId) {
          this.tournamentId = this.turnamen[0].id;
          await this.muatSemua();
        }
      } catch (e) {
        this.toast.error('Gagal memuat data awal.');
      }
    },

    async muatSemua() {
      this.jenisList = [];
      this.tarifList = [];
      this.tarifBaru = this.tarifKosong();

      if (!this.tournamentId) return;

      try {
        const [j, t] = await Promise.all([
          http.get('/jenis-pertandingan', { params: { tournament_id: this.tournamentId } }),
          http.get('/tarif-pendaftaran', { params: { tournament_id: this.tournamentId } }),
        ]);

        this.jenisList = this.isi(j);
        this.tarifList = this.isi(t);
        await this.muatMatriks();
        await this.muatKuota();
      } catch (e) {
        this.toast.error('Gagal memuat jenis dan tarif.');
      }
    },

    isiCepatTanding(nama) {
      this.jenisTandingBaru = nama;
      this.tambahJenis(1);
    },

    async aturKuotaKelas(ids, nilai) {
      const kuota = nilai === '' || nilai === null || nilai === undefined ? null : Number(nilai);
      if (kuota !== null && (!Number.isInteger(kuota) || kuota < 1 || kuota > 512)) {
        this.toast.error('Batas harus angka bulat 1–512, atau kosong untuk tanpa batas.');
        return;
      }
      this.sibuk = true;
      try {
        const { data } = await http.post('/kuota-klasifikasi', { tournament_id: this.tournamentId, detail_ids: ids, kuota });
        this.toast.success(data.message);
        await this.muatKuota();
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan batas.');
      } finally {
        this.sibuk = false;
      }
    },

    async muatKuota() {
      try {
        const { data: kelas } = await http.get('/kuota-klasifikasi', { params: { tournament_id: this.tournamentId } });
        this.kuotaKelasList = (kelas || []).map((g) => ({ ...g, massal: '' }));
      } catch (e) {
        this.kuotaKelasList = [];
      }
      try {
        const { data: ev } = await http.get('/kuota-event', { params: { tournament_id: this.tournamentId } });
        this.kuotaEvent = ev;
        this.kuotaEventInput = ev.kuota ?? '';
      } catch (e) { /* biarkan */ }
      try {
        const { data: seni } = await http.get('/kuota-seni', { params: { tournament_id: this.tournamentId } });
        this.kuotaSeni = { usia: [], nomor: (seni.nomor || []).map((n) => ({ ...n, massal: '' })) };
      } catch (e) {
        this.kuotaSeni = { usia: [], nomor: [] };
      }
      const { data } = await http.get('/tournament-age-categories', {
        params: { tournament_id: this.tournamentId, per_page: 100 },
      });
      const isi = data?.data?.data || data?.data || [];
      this.kuotaList = Array.isArray(isi) ? isi.filter((k) => String(k.tournament_id) === String(this.tournamentId)) : [];
    },

    async ubahKuota(k, kolom, nilai) {
      const angka = nilai === '' ? null : Number(nilai);
      if (angka !== null && (!Number.isInteger(angka) || angka < 2 || angka > 512)) {
        this.toast.error('Batas harus angka bulat 2–512, atau kosong untuk tanpa batas.');
        await this.muatKuota();
        return;
      }
      this.sibuk = true;
      try {
        await http.put(`/tournament-age-categories/${k.id}`, { [kolom]: angka });
        k[kolom] = angka;
        this.toast.success(angka === null ? 'Batas dihapus.' : 'Batas disimpan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan batas.');
        await this.muatKuota();
      } finally {
        this.sibuk = false;
      }
    },

    async simpanKuota(g, items, nilai) {
      if (g.jenis === 'seni') return this.aturKuotaSeni(items.map((i) => [i.mc, i.age]), nilai);
      if (g.jenis === 'kelas') return this.aturKuotaKelas(items.map((i) => i.id), nilai);
      for (const i of items) await this.ubahKuota(i.ref, 'kuota_per_kelas', nilai);
      return null;
    },

    async aturKuotaEvent() {
      const v = this.kuotaEventInput === '' || this.kuotaEventInput === null ? null : Number(this.kuotaEventInput);
      this.sibuk = true;
      try {
        const { data } = await http.post('/kuota-event', { tournament_id: this.tournamentId, kuota: v });
        this.kuotaEvent = data;
        this.kuotaEventInput = data.kuota ?? '';
        this.toast.success(data.message || 'Tersimpan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan batas event.');
      } finally {
        this.sibuk = false;
      }
    },

    async aturKuotaSeni(sel, nilai) {
      const angka = nilai === '' || nilai === null ? null : Number(nilai);
      if (angka !== null && (!Number.isInteger(angka) || angka < 1 || angka > 512)) {
        this.toast.error('Batas harus angka bulat 1–512, atau kosong untuk tanpa batas.');
        await this.muatKuota();
        return;
      }
      this.sibuk = true;
      try {
        const { data } = await http.post('/kuota-seni', {
          tournament_id: this.tournamentId,
          kuota: angka,
          sel: sel.map(([m, a]) => ({ match_category_id: m, age_category_id: a })),
        });
        this.toast.success(data?.message || 'Batas disimpan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan batas.');
      } finally {
        await this.muatKuota();
        this.sibuk = false;
      }
    },

    async muatMatriks() {
      const { data } = await http.get('/kategori-seni', { params: { tournament_id: this.tournamentId } });
      this.matriksSeni = data.baris || [];
    },

    judulCentang(b, t) {
      const sel = b.tingkat[t];
      if (t === 'Khusus' && !this.isOwner) return 'Hanya super admin';
      if (sel.dibuka && sel.atlet) return `Sudah dipakai ${sel.atlet} atlet, tidak bisa ditutup`;
      return '';
    },

    async aturSeni(b, tingkat, buka) {
      this.sibuk = true;
      try {
        const { data } = await http.post('/kategori-seni', {
          tournament_id: this.tournamentId,
          nomor: b.nomor,
          varian: b.varian,
          tingkat,
          buka,
        });
        this.toast.success(data.message);
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan.');
      } finally {
        await this.muatSemua();
        this.sibuk = false;
      }
    },

    /** Baris baru baru tersimpan setelah salah satu tingkatnya dicentang. */
    tambahBarisSeni() {
      const varian = this.barisBaru.varian.replace(/\s+/g, ' ').trim()
        .replace(/\b\w/g, (h) => h.toUpperCase());
      const label = `${this.barisBaru.nomor} ${varian}`;
      if (this.matriksSeni.some((b) => b.label.toLowerCase() === label.toLowerCase())) {
        this.toast.info(`${label} sudah ada di tabel.`);
        return;
      }
      const kosong = { dibuka: false, jenis_pertandingan_id: null, atlet: 0 };
      this.matriksSeni.push({
        nomor: this.barisBaru.nomor,
        varian,
        label,
        tingkat: { Prestasi: { ...kosong }, Pemasalan: { ...kosong }, Khusus: { ...kosong } },
      });
      this.barisBaru.varian = '';
      this.toast.info(`Centang tingkat untuk ${label} supaya tersimpan.`);
    },

    async tambahJenis(championshipCategoryId) {
      const name = championshipCategoryId === 1 ? this.jenisTandingBaru : this.jenisSeniBaru;
      if (!name) return;
      const daftar = championshipCategoryId === 1 ? this.jenisTandingList : this.jenisSeniList;
      if (daftar.some((j) => (j.name || '').trim().toLowerCase() === name.toLowerCase())) {
        this.toast.info(`"${name}" sudah ada di daftar.`);
        return;
      }

      this.sibuk = true;
      try {
        await http.post('/jenis-pertandingan', {
          tournament_id: this.tournamentId,
          name,
          championship_category_id: championshipCategoryId,
        });
        if (championshipCategoryId === 1) this.jenisTandingBaru = '';
        else this.jenisSeniBaru = '';
        await this.muatSemua();
        this.toast.success('Jenis ditambahkan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menambah jenis.');
      } finally {
        this.sibuk = false;
      }
    },

    async ubahJenis(j) {
      try {
        await http.put(`/jenis-pertandingan/${j.id}`, { name: j.name });
        this.toast.success('Nama jenis disimpan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan.');
        await this.muatSemua();
      }
    },

    /*
     * Penghapusan bisa ditolak server kalau jenisnya masih dipakai atlet.
     * Pesannya diteruskan apa adanya — di situ ada jumlah atlet yang
     * terpengaruh, dan itu yang menentukan langkah panitia berikutnya.
     */
    async hapusJenis(j) {
      if (!window.confirm(`Hapus jenis "${j.name}"?`)) return;

      this.sibuk = true;
      try {
        await http.delete(`/jenis-pertandingan/${j.id}`);
        await this.muatSemua();
        this.toast.success('Jenis dihapus.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menghapus jenis.');
      } finally {
        this.sibuk = false;
      }
    },

    async ubahBiaya(t, nilai) {
      const biaya = Number(nilai);
      if (!Number.isFinite(biaya) || biaya < 0) return;
      this.sibuk = true;
      try {
        await http.put(`/tarif-pendaftaran/${t.id}`, {
          tournament_id: this.tournamentId,
          championship_category_id: t.championship_category_id,
          jenis_pertandingan_id: t.jenis_pertandingan_id,
          age_category_id: t.age_category_id,
          biaya,
        });
        t.biaya = biaya;
        this.toast.success('Biaya disimpan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan biaya.');
        await this.muatSemua();
      } finally {
        this.sibuk = false;
      }
    },

    pilihGolonganSaat(syarat) {
      this.pilihGolongan = this.golonganUrai.filter(syarat).map((g) => g.id);
    },

    alihkanGrup(k) {
      const id = k.isi.map((g) => g.id);
      const semua = id.every((x) => this.pilihGolongan.includes(x));
      this.pilihGolongan = semua
        ? this.pilihGolongan.filter((x) => !id.includes(x))
        : [...new Set([...this.pilihGolongan, ...id])];
    },

    async simpanMassal() {
      this.sibuk = true;
      try {
        const { data } = await http.post('/tarif-pendaftaran/massal', {
          tournament_id: this.tournamentId,
          jenis_pertandingan_ids: this.pilihGolongan,
          age_category_ids: this.pilihUsia,
          biaya: this.biayaMassal,
        });
        this.toast.success(data.message);
        this.pilihGolongan = [];
        this.biayaMassal = null;
        await this.muatSemua();
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan tarif.');
      } finally {
        this.sibuk = false;
      }
    },

    async hapusTarif(t) {
      if (!window.confirm('Hapus baris tarif ini?')) return;

      this.sibuk = true;
      try {
        await http.delete(`/tarif-pendaftaran/${t.id}`);
        await this.muatSemua();
        this.toast.success('Tarif dihapus.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menghapus tarif.');
      } finally {
        this.sibuk = false;
      }
    },
  },
  computed: {
    grupTanding() {
      const g = (j) => (j === 'female' ? 'Putri' : 'Putra');
      if (this.kuotaKelasList.length) {
        return this.kuotaKelasList.map((k) => ({
          key: `k${k.klasifikasi_id}`, jenis: 'kelas', judul: k.judul, satuan: 'kelas', massal: k.massal,
          items: k.kelas.map((c) => ({ key: c.id, id: c.id, label: `${c.kelas} ${g(c.gender)}`, sub: c.berat, kuota: c.kuota })),
        }));
      }
      if (!this.kuotaList.length) return [];
      return [{
        key: 'usia', jenis: 'usia', judul: 'Per kelas, menurut usia', satuan: 'usia', massal: '',
        items: this.kuotaList.map((k) => ({ key: k.id, ref: k, label: k.age_category?.name || k.ageCategory?.name || '-', kuota: k.kuota_per_kelas })),
      }];
    },
    grupSeni() {
      return this.kuotaSeni.nomor.map((n) => ({
        key: `s${n.id}`, jenis: 'seni', judul: `${n.kategori} ${n.tingkat}`, satuan: 'usia', massal: n.massal,
        items: n.usia.map((u) => ({ key: u.id, mc: n.id, age: u.id, label: u.nama, kuota: u.kuota })),
      }));
    },
    kelompokKuotaSeni() {
      const peta = new Map();
      for (const n of this.kuotaSeni.nomor) {
        if (!peta.has(n.nomor)) peta.set(n.nomor, { nomor: n.nomor, isi: [] });
        peta.get(n.nomor).isi.push(n);
      }
      return [...peta.values()];
    },
    turnamenTerpilih() {
      return this.turnamen.find((t) => String(t.id) === String(this.tournamentId)) || null;
    },
    /** Jenis khusus Tanding (championship_category_id = 1) atau null (semua) */
    isiCepatTersisa() {
      const ada = new Set(this.jenisTandingList.map((j) => (j.name || '').trim().toLowerCase()));
      return ['Pemasalan', 'Prestasi', 'Invitasi'].filter((n) => !ada.has(n.toLowerCase()));
    },
    jenisTandingList() {
      return this.jenisList.filter(
        (j) => j.championship_category_id === 1 || j.championship_category_id === null
      );
    },
    isOwner() {
      return isOwner();
    },
    /** Golongan tarif yang sudah diurai jadi nomor / kategori / tingkat. */
    golonganUrai() {
      return this.jenisList
        .filter((j) => j.championship_category_id === 1 || j.championship_category_id === 2)
        .map((j) => ({ ...j, ...uraiGolongan(j.name, j.championship_category_id) }));
    },
    /** Pilihan kategori di form massal, dikelompokkan seperti tabelnya. */
    kelompokGolongan() {
      const grup = new Map();
      this.golonganUrai.forEach((g) => {
        const judul = Number(g.championship_category_id) === 1 ? 'Tanding' : `Seni — ${g.nomor || 'Lainnya'}`;
        const labelPendek = Number(g.championship_category_id) === 1
          ? (g.tingkat || g.name)
          : [g.varian, g.tingkat].filter(Boolean).join(' ') || g.name;
        if (!grup.has(judul)) grup.set(judul, []);
        grup.get(judul).push({ ...g, labelPendek });
      });
      const urutan = ['Tanding', ...URUT_NOMOR.map((n) => `Seni — ${n}`), 'Seni — Lainnya'];
      return [...grup.entries()]
        .sort(([a], [b]) => urutan.indexOf(a) - urutan.indexOf(b))
        .map(([judul, isi]) => ({
          judul,
          isi: isi.sort((a, b) => (a.varian || '').localeCompare(b.varian || '') || TINGKAT.indexOf(a.tingkat) - TINGKAT.indexOf(b.tingkat)),
        }));
    },
    jumlahKombinasi() {
      return this.pilihGolongan.length * (this.pilihUsia.length || 1);
    },
    /** Tabel tarif dikelompokkan: Tanding, lalu Seni per nomor. */
    kelompokTarif() {
      const urutUsia = new Map(this.usia.map((u, i) => [u.id, i]));
      const baris = this.tarifList.map((t) => {
        const u = uraiGolongan(t.jenis_pertandingan?.name, t.championship_category_id);
        const kategori = u.nomor && u.nomor !== 'Tanding' ? [u.nomor, u.varian].filter(Boolean).join(' ') : (u.varian || '');
        return { ...t, _urai: { ...u, kategori } };
      });
      const kunci = (t) => (Number(t.championship_category_id) === 1 ? 'Tanding' : `Seni — ${t._urai.nomor || 'Lainnya'}`);
      const urutan = ['Tanding', ...URUT_NOMOR.map((n) => `Seni — ${n}`), 'Seni — Lainnya'];
      const grup = new Map();
      baris.forEach((t) => {
        const k = kunci(t);
        if (!grup.has(k)) grup.set(k, []);
        grup.get(k).push(t);
      });
      return [...grup.entries()]
        .sort(([a], [b]) => urutan.indexOf(a) - urutan.indexOf(b))
        .map(([judul, isi]) => ({
          judul,
          adaKategori: judul !== 'Tanding',
          baris: isi.sort((a, b) =>
            (a._urai.kategori || '').localeCompare(b._urai.kategori || '')
            || TINGKAT.indexOf(a._urai.tingkat) - TINGKAT.indexOf(b._urai.tingkat)
            || (urutUsia.get(a.age_category_id) ?? -1) - (urutUsia.get(b.age_category_id) ?? -1)),
        }));
    },
    /** Golongan seni yang bukan bagian tabel (mis. "Tunggal Prestasi" lama). */
    golonganSeniLain() {
      const dariTabel = new Set();
      this.matriksSeni.forEach((b) => Object.values(b.tingkat).forEach((c) => c.jenis_pertandingan_id && dariTabel.add(c.jenis_pertandingan_id)));
      return this.jenisList.filter((j) => j.championship_category_id === 2 && !dariTabel.has(j.id));
    },
    /** Jenis khusus Seni (championship_category_id = 2) atau null (semua) */
    jenisSeniList() {
      return this.jenisList.filter(
        (j) => j.championship_category_id === 2 || j.championship_category_id === null
      );
    },
  },
};
</script>

<style scoped>
/* HP: tabel tarif tidak dipaksa selebar layar (isinya jadi terpotong); geser ke samping. */
@media (max-width: 640px) {
  .jt__grup .jt__tabel { table-layout: auto; min-width: 560px; }
}

.bp-event { display: grid; gap: var(--space-2); padding: var(--space-3) var(--space-4); margin: var(--space-3) 0 var(--space-4); border: 1px solid var(--border-subtle); border-radius: 12px; background: var(--bg-sunken); }
.bp-event--penuh { border-color: #e5484d; }
.bp-event__info { display: flex; flex-wrap: wrap; align-items: baseline; gap: var(--space-2) var(--space-3); }
.bp-event__label { font-size: var(--text-sm); color: var(--text-secondary); }
.bp-event__angka { font-size: 1.4rem; font-variant-numeric: tabular-nums; }
.bp-event__angka span { color: var(--text-muted); font-weight: 500; }
.bp-tag { font-size: var(--text-xs); padding: 2px 8px; border-radius: 999px; background: var(--bg-surface, #fff); border: 1px solid var(--border-subtle); color: var(--text-secondary); }
.bp-tag--merah { background: #e5484d; border-color: #e5484d; color: #fff; }
.bp-bar { height: 6px; border-radius: 999px; background: var(--border-subtle); overflow: hidden; }
.bp-bar span { display: block; height: 100%; background: var(--brand-primary, #2563eb); }
.bp-event--penuh .bp-bar span { background: #e5484d; }
.bp-isi { display: flex; gap: var(--space-2); align-items: center; }
.bp-input { width: 88px !important; padding: 4px 8px; text-align: right; font-variant-numeric: tabular-nums; }
.bp-tab { display: inline-flex; gap: 2px; padding: 3px; margin-bottom: var(--space-3); border-radius: 10px; background: var(--bg-sunken); }
.bp-tab button { border: 0; background: transparent; padding: 6px 16px; border-radius: 8px; font-weight: 600; font-size: var(--text-sm); color: var(--text-secondary); cursor: pointer; }
.bp-tab button.aktif { background: var(--bg-surface, #fff); color: var(--text-primary); box-shadow: 0 1px 2px rgba(0,0,0,.08); }
.bp-grup { padding: var(--space-3) 0; border-top: 1px solid var(--border-subtle); }
.bp-grup__kepala { display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: var(--space-2); margin-bottom: var(--space-2); }
.bp-redup { margin-left: var(--space-2); font-size: var(--text-xs); color: var(--text-muted); }
.bp-daftar { display: grid; grid-template-columns: repeat(auto-fill, minmax(210px, 1fr)); gap: 6px var(--space-3); }
.bp-item { display: flex; align-items: center; justify-content: space-between; gap: var(--space-2); margin: 0; padding: 4px 4px 4px 10px; border-radius: 8px; background: var(--bg-sunken); font-size: var(--text-sm); }
.bp-item__nama { display: flex; flex-direction: column; line-height: 1.2; }
.bp-item__nama small { font-size: var(--text-xs); color: var(--text-muted); }
.jt__kuota-grup { margin-top: var(--space-3); padding: var(--space-3); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg, 12px); }
.jt__kuota-kepala { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: var(--space-3); margin-bottom: var(--space-2); }
.jt__kuota-massal { display: flex; gap: var(--space-2); align-items: center; }
.jt__kuota-massal .jt__biaya { margin-left: 0; width: 130px; }
.jt__redup { margin-left: var(--space-2); font-size: var(--text-xs); color: var(--text-muted); }

.jt__massal { display: flex; flex-direction: column; gap: var(--space-4); padding: var(--space-4); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg, 12px); background: var(--bg-sunken); }
.jt__massal-blok { border: 0; margin: 0; padding: 0; min-width: 0; }
.jt__massal-blok legend { display: flex; align-items: center; gap: var(--space-2); margin-bottom: var(--space-2); }
.jt__hitung { font-weight: 500; font-size: var(--text-xs); color: var(--text-secondary); }
.jt__pintasan { display: flex; flex-wrap: wrap; gap: var(--space-2); margin-bottom: var(--space-3); }
.jt__pintas { font: inherit; font-size: var(--text-xs); font-weight: 600; padding: 4px var(--space-3); border-radius: var(--radius-full); border: 1px solid var(--border-strong); background: var(--bg-surface); color: var(--text-primary); cursor: pointer; }
.jt__pintas:hover { border-color: var(--accent); }
.jt__pintas--redup { color: var(--text-secondary); }
.jt__massal-grup { padding: var(--space-3) 0; border-top: 1px dashed var(--border-subtle); }
.jt__massal-grup-kepala { display: flex; align-items: center; justify-content: space-between; gap: var(--space-2); margin-bottom: var(--space-2); font-size: var(--text-sm); }
.jt__chip-daftar { display: flex; flex-wrap: wrap; gap: var(--space-2); }
.jt__chip { display: inline-flex; align-items: center; gap: var(--space-2); min-height: 40px; padding: 0 var(--space-3); font-size: var(--text-sm); font-weight: 500; border: 1px solid var(--border-strong); border-radius: var(--radius-full); background: var(--bg-surface); cursor: pointer; user-select: none; }
.jt__chip input { width: 16px; height: 16px; accent-color: var(--accent); }
.jt__chip--aktif { border-color: var(--accent); background: var(--accent-subtle); color: var(--text-brand); }
.jt__chip:focus-within { box-shadow: 0 0 0 3px var(--accent-subtle); }
.jt__massal-kaki { display: flex; flex-wrap: wrap; align-items: flex-end; gap: var(--space-3); }
.jt__massal-biaya { flex: 1 1 220px; max-width: 320px; }

.jt__grup { margin-top: var(--space-5); }
.jt__grup-judul { display: flex; align-items: center; gap: var(--space-2); margin: 0 0 var(--space-2); font-size: var(--text-md); font-weight: 700; }
.jt__grup-judul span { font-size: var(--text-xs); font-weight: 600; padding: 1px var(--space-2); border-radius: var(--radius-full); background: var(--bg-sunken); color: var(--text-secondary); }
.jt__grup .jt__tabel { table-layout: fixed; width: 100%; }
.jt__grup .jt__tabel th:last-child { width: 64px; }
.jt__grup .jt__tabel th:nth-last-child(2) { width: 170px; }
.jt__grup .jt__tabel th:nth-last-child(3) { width: 26%; }
.jt__grup .jt__tabel th:nth-last-child(4) { width: 18%; }
.jt__biaya { max-width: 140px; margin-left: auto; text-align: right; font-variant-numeric: tabular-nums; }

.jt__matriks { width: 100%; border-collapse: collapse; font-size: var(--text-sm); }
.jt__matriks th, .jt__matriks td { padding: var(--space-2) var(--space-3); border-bottom: 1px solid var(--border-subtle); text-align: left; }
.jt__matriks thead th { font-size: var(--text-xs); text-transform: uppercase; letter-spacing: 0.04em; color: var(--text-secondary); }
.jt__matriks tbody th { font-weight: 600; white-space: nowrap; }
.jt__tengah { text-align: center !important; }
.jt__catatan { display: block; font-size: 0.65rem; text-transform: none; letter-spacing: 0; color: var(--text-muted); font-weight: 500; }
.jt__centang { display: inline-flex; flex-direction: column; align-items: center; gap: 2px; min-width: 44px; min-height: 32px; justify-content: center; cursor: pointer; }
.jt__centang input { width: 18px; height: 18px; accent-color: var(--accent); cursor: pointer; }
.jt__centang input:disabled { cursor: not-allowed; }
.jt__atlet { font-size: 0.65rem; color: var(--text-muted); }
.jt__pendek { max-width: 160px; }
.jt__lama summary { cursor: pointer; font-size: var(--text-sm); color: var(--text-secondary); }

.page-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.jt__blok {
  margin-bottom: 1.25rem;
}

.jt__judul {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.jt__nomor {
  display: inline-grid;
  place-items: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: var(--grad-flame, #ea580c);
  color: #fff;
  font-size: 0.9rem;
}

.jt__teks {
  font-size: 0.9rem;
  line-height: 1.55;
  color: var(--text-secondary, #6b7280);
  margin-bottom: 1rem;
}

.jt__baris-tambah {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.jt__baris-tambah .ui-input {
  flex: 1 1 220px;
}

.jt__daftar {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 0.5rem;
}

.jt__item {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.jt__item-nama {
  flex: 1 1 auto;
}

.jt__kosong {
  font-size: 0.9rem;
  color: #b45309;
  background: rgba(217, 119, 6, 0.1);
  padding: 0.65rem 0.8rem;
  border-radius: 8px;
  line-height: 1.5;
}

.jt__form-tarif {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
  align-items: end;
  margin-bottom: 1.25rem;
}

.jt__tabel-bungkus {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}

.jt__tabel {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.jt__tabel th,
.jt__tabel td {
  padding: 0.55rem 0.6rem;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  text-align: left;
  white-space: nowrap;
}

.jt__kanan {
  text-align: right;
}

.jt__sub-jenis {
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  padding: 0.8rem 1rem;
}

.jt__sub-judul {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.jt__badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
}

.jt__badge--tanding {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
}

.jt__badge--seni {
  background: rgba(234, 179, 8, 0.12);
  color: #b45309;
}
</style>
